export default __webpack_public_path__ + "static/media/qualityLife.ec0e5faf.jpg";